import { setSettingsMutation } from "relay/main";
import { getPropertyId } from "common";
import * as mainApis from "relay/event";
import uploadCsv from "relay/event/mutations/uploadCsv";
import importCsv from "relay/event/mutations/importCsv";
import undoImport from "relay/event/mutations/undoImport";

// Universal BCC
export const saveSetting = async (data) => {
  return new Promise((resolve, reject) => {
    setSettingsMutation(data)
      .then((res) => {
        if (res.errors || res.error) reject(res);
        resolve(res.saveHyeventsSetting.hyeventsSetting);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Broker Uploads
const callImportLogs = async () => {
  try {
    let data = await mainApis.importLogs(getPropertyId());
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

const callContactGroups = async () => {
  try {
    let data = await mainApis.getContactGroups(getPropertyId());
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

export const getImportLogs = async () => {
  const { data, error } = await callImportLogs();

  return new Promise((resolve, reject) => {
    if (!!error || !data.importLogs.edges) reject(error);
    else {
      const importLogs = data.importLogs.edges.map((item) => item.node);
      resolve(importLogs);
    }
  });
};

export const getContactGroups = async () => {
  const { data, error } = await callContactGroups();

  return new Promise((resolve, reject) => {
    if (!!error || !data.contactGroups) reject(error);
    else {
      const broker = data.contactGroups.find(
        (contact) => contact.name === "Broker" && contact.status.includes("Broker")
      );
      resolve(broker);
    }
  });
};

// Broker Uploads
export const uploadCSV = async (data) => {
  return new Promise(function (resolve, reject) {
    uploadCsv(data, (res, err) => {
      if (err || res.errors || res.error) reject();
      resolve(res.uploadCsv.csvFile);
    });
  });
};

export const importCSV = async (data) => {
  return new Promise(function (resolve, reject) {
    importCsv(data, (res, err) => {
      if (err || res.errors || res.error) reject();
      if (res && res.importCsv) resolve();
    });
  });
};

export const archiveCSV = async (logId) => {
  const inputData = {
    propertyId: getPropertyId(),
    logId,
  };
  return new Promise(function (resolve, reject) {
    undoImport(inputData, (res, err) => {
      if (err) {
        resolve(err[0]);
      }
      resolve(res.undoImport);
    });
  });
};

